import React, { useState } from 'react';
import { Layout, Menu, Button, Space, Typography, message, Dropdown } from 'antd';
import {
    DashboardOutlined,
    TagsOutlined,
    UploadOutlined,
    LogoutOutlined,
    UserOutlined,
    FileImageOutlined,
    DesktopOutlined,
    SortAscendingOutlined,
    LockOutlined,
    DownOutlined,
    AppstoreOutlined,
    SettingOutlined,
    FolderOpenOutlined,
    KeyOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const AppLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useAuth();
    const [collapsed, setCollapsed] = useState(false);


    const siderStyle: React.CSSProperties = {
        overflow: 'auto',
        height: '100vh',
        position: 'sticky',
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: 'thin',
        scrollbarGutter: 'stable',
    };

    const menuItems = [
        {
            key: '/dashboard',
            icon: <DashboardOutlined />,
            label: '仪表板',
        },
        {
            key: '/upload',
            icon: <UploadOutlined />,
            label: '图片上传',
        },
        {
            key: '/image-list',
            icon: <FileImageOutlined />,
            label: '图片列表',
        },
        {
            key: '/tag-management',
            icon: <TagsOutlined />,
            label: '标签管理',
        },
        // {
        //     key: '/image-tagging',
        //     icon: <PictureOutlined />,
        //     label: '图片标记',
        // },
        {
            key: '/device-type-management',
            icon: <DesktopOutlined />,
            label: '设备类型管理',
        },
        {
            key: '/sort-category-management',
            icon: <SortAscendingOutlined />,
            label: '排序类别管理',
        },
        {
            key: '/material-management',
            icon: <FolderOpenOutlined />,
            label: '素材管理',
        },
        {
            key: '/flash-writer-auth-code-management',
            icon: <KeyOutlined />,
            label: '授权码管理',
        },
        {
            key: 'app-menu',
            icon: <AppstoreOutlined />,
            label: '应用',
            children: [
                {
                    key: '/app-management',
                    icon: <SettingOutlined />,
                    label: '应用管理',
                },
                {
                    key: '/firmware-version-management',
                    icon: <SettingOutlined />,
                    label: '固件管理',
                },
                {
                    key: '/app-version-management',
                    icon: <SettingOutlined />,
                    label: '应用版本管理',
                },
            ],
        },
    ];

    const handleMenuClick = ({ key }: { key: string }) => {
        navigate(key);
    };

    const handleLogout = () => {
        logout();
        message.success('退出登录成功');
        navigate('/login');
    };

    const handleChangePassword = () => {
        navigate('/change-password');
    };

    const userMenuItems = [
        {
            key: 'change-password',
            icon: <LockOutlined />,
            label: '修改密码',
            onClick: handleChangePassword,
        },
        {
            type: 'divider' as const,
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: '退出登录',
            onClick: handleLogout,
        },
    ];

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider width={240} theme="dark" collapsible collapsed={collapsed} onCollapse={setCollapsed} style={siderStyle}>
                <div style={{
                    padding: '16px',
                    textAlign: 'center',
                    borderBottom: '1px solid #333'
                }}>
                    <Title
                        level={4}
                        style={{
                            color: 'white',
                            margin: 0,
                            fontWeight: 'bold'
                        }}
                    >
                        Pixel Creator
                    </Title>
                    <div style={{ color: '#888', fontSize: '12px', marginTop: '4px' }}>
                        后台管理系统
                    </div>
                </div>

                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    items={menuItems}
                    onClick={handleMenuClick}
                    style={{ borderRight: 0, marginTop: '16px' }}
                />
            </Sider>

            <Layout>
                <Header style={{
                    padding: '0 24px',
                    background: '#fff',
                    borderBottom: '1px solid #f0f0f0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div />
                    <Dropdown
                        menu={{ items: userMenuItems }}
                        placement="bottomRight"
                        trigger={['click']}
                    >
                        <Button type="text" style={{ display: 'flex', alignItems: 'center' }}>
                            <Space>
                                <UserOutlined />
                                <span>欢迎，{user?.username}</span>
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                </Header>

                <Content style={{
                    margin: '24px',
                    padding: '24px',
                    background: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppLayout; 